export default __webpack_public_path__ + "static/media/icon-pdf.6a9528b9.svg";